import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { PencilIcon, ChevronLeftIcon } from "@primer/octicons-react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import ContentLoader from "react-content-loader";
import Form from "react-bootstrap/Form";
import ListGroup from "react-bootstrap/ListGroup";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import Swal from "sweetalert2";

import { BASENAME, REST_API } from "../../../../services/constants";
import authHeader from "../../../../services/auth-header";
import { goBackInHistory } from "../../../../services/constants";

export default function AdminDashboardShowUserPage(props) {
  let { userId } = useParams();

  const [userDetails, setUserDetails] = useState(null);
  const [groups, setGroups] = useState(null);

  const updateUserDetails = async () => {
    axios({
      method: "GET",
      url: `${REST_API}/api/secure/users/${userId}`,
      headers: await authHeader(),
    }).then((response) => {
      if (response.status == 200) {
        setUserDetails(response.data);
      }
    });
  };

  const applyUserDetailChanges = async () => {
    axios({
      method: "PATCH",
      url: `${REST_API}/api/secure/users/${userId}`,
      headers: await authHeader(),
      data: {
        email: userDetails.email,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          updateUserDetails();

          Toast.fire({
            icon: "success",
            title: "Änderungen gespeichert",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Änderungen nicht gespeichert",
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          Toast.fire({
            icon: "error",
            title: "Unbekannter Fehler",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Keine Internetverbindung",
          });
        }
      });
  };

  const updateGroups = async () => {
    axios({
      method: "GET",
      url: `${REST_API}/api/secure/groups/`,
      headers: await authHeader(),
    }).then((response) => {
      if (response.status == 200) {
        setGroups(response.data);
      }
    });
  };

  const addUserToGroup = async (groupId) => {
    axios({
      method: "POST",
      url: `${REST_API}/api/secure/users/${userId}/groups/${groupId}/`,
      headers: await authHeader(),
    })
      .then((response) => {
        if (response.status == 200) {
          updateUserDetails();

          Toast.fire({
            icon: "success",
            title: "Gruppen gespeichert",
          });
        } else if (response.status == 304) {
          Toast.fire({
            icon: "warning",
            title: "Änderung nicht gespeichert",
          });
        } else {
          Toast.fire({
            icon: "warning",
            title: "Speichern fehlgeschlagen.",
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.status == 400) {
          Toast.fire({
            icon: "warning",
            title: "Kann nicht gespeichert werden",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Speichern fehlgeschlagen",
          });
        }
      });
  };

  const removeUserFromGroup = async (groupId) => {
    axios({
      method: "DELETE",
      url: `${REST_API}/api/secure/users/${userId}/groups/${groupId}/`,
      headers: await authHeader(),
    })
      .then((response) => {
        if (response && response.status === 200) {
          updateUserDetails();

          Toast.fire({
            icon: "success",
            title: "Gruppen gespeichert",
          });
        } else {
          Toast.fire({
            icon: "warning",
            title: "Speichern fehlgeschlagen.",
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.status == 400) {
          Toast.fire({
            icon: "warning",
            title: "Kann nicht gespeichert werden",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Speichern fehlgeschlagen",
          });
        }
      });
  };

  const toggleGroup = (groupId) => {
    if (userDetails.roles.map((x) => x.id).includes(groupId)) {
      console.log("Removing " + userId + " to group " + groupId);
      removeUserFromGroup(groupId);
    } else {
      console.log("Adding " + userId + " from group " + groupId);
      addUserToGroup(groupId);
    }
  };

  useEffect(() => {
    updateUserDetails();
    updateGroups();
  }, []);

  const showUpdateLastNameModal = () => {
    Swal.fire({
      icon: "info",
      title: "Nachname ändern",
      input: "text",
      inputLabel: "Neuer Nachname",
      inputValue: userDetails.lastName,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Der Name darf nicht leer sein";
        }

        if (value.length < 2) {
          return "Der Name muss 2 Zeichen oder länger sein";
        }

        if (value.length > 50) {
          return "Der Name darf nicht länger als 50 Zeichen sein";
        }
      },
    }).then((x) => {
      if (x.isConfirmed) {
        userDetails.lastName = x.value;
        applyUserDetailChanges();
      }
    });
  };

  return (
    <>
      <Card>
        <Card.Header>
          <Button onClick={() => goBackInHistory(props)} className="mr-4 py-2">
            <ChevronLeftIcon />
            Zurück
          </Button>
          Benutzer bearbeiten
        </Card.Header>
        {userDetails === null || userDetails === undefined ? (
          <Card.Body>
            <FormSkeleton style={{ maxWidth: 1000 }} />
          </Card.Body>
        ) : (
          <>
            <ListGroup className="list-group-flush">
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>E-Mail</b>
                    <br />
                    <p>
                      {userDetails.email ||
                        userDetails.username ||
                        "Keine Email angegeben"}
                    </p>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Vorname</b>
                    <br />
                    <p>{userDetails.firstName}</p>
                  </div>
                  <div className="col-md-auto align-self-end">
                    <Button
                      onClick={() => showUpdateFirstNameModal()}
                      className="btn btn-primary"
                    >
                      <PencilIcon size={16} className="mr-2" />
                      Ändern
                    </Button>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Nachname</b>
                    <br />
                    <p>{userDetails.lastName}</p>
                  </div>
                  <div className="col-md-auto align-self-end">
                    <Button
                      onClick={() => showUpdateLastNameModal()}
                      className="btn btn-primary"
                    >
                      <PencilIcon size={16} className="mr-2" />
                      Ändern
                    </Button>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <div className="row">
                  <div className="col">
                    <b>Gruppen</b>
                    <br />
                    {groups === null || groups === undefined ? (
                      <span>Loading...</span>
                    ) : (
                      groups.map((group, index) => {
                        return (
                          <Form.Check
                            key={index}
                            custom
                            type="checkbox"
                            id={`custom-${index}`}
                            label={group.name}
                            defaultChecked={userDetails.roles
                              .map((x) => x.id)
                              .includes(group.id)}
                            onChange={() => toggleGroup(group.id)}
                          />
                        );
                      })
                    )}
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          </>
        )}
      </Card>
    </>
  );
}

const FormSkeleton = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 400 200"
      backgroundColor="#d9d9d9"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="15" y="15" rx="4" ry="4" width="130" height="10" />
      <rect x="155" y="15" rx="3" ry="3" width="130" height="10" />
      <rect x="295" y="15" rx="3" ry="3" width="90" height="10" />
      <rect x="15" y="50" rx="3" ry="3" width="90" height="10" />
      <rect x="115" y="50" rx="3" ry="3" width="60" height="10" />
      <rect x="185" y="50" rx="3" ry="3" width="200" height="10" />
      <rect x="15" y="90" rx="3" ry="3" width="130" height="10" />
      <rect x="160" y="90" rx="3" ry="3" width="120" height="10" />
      <rect x="290" y="90" rx="3" ry="3" width="95" height="10" />
      <rect x="15" y="130" rx="3" ry="3" width="130" height="10" />
      <rect x="160" y="130" rx="3" ry="3" width="225" height="10" />
    </ContentLoader>
  );
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
